const STATUS_OPTIONS = {
  actives: true,
  inactives: false,
} as const;

export const STATUS_PER_DEFAULT = STATUS_OPTIONS.actives;
export const USER_CONNECTION_TIMEOUT_MINUTES = 30;
/** Positions older than this are still drawn but dimmed on the map. */
export const POSITION_STALE_TIMEOUT_MINUTES = 30;
export const LOW_BATTERY_THRESHOLD = 20;
/** Refresh cadence for time-derived values (connected flag, relative last-seen labels). */
export const STATUS_TICK_INTERVAL_MS = 60 * 1000;
export const DEFAULT_SORT_STATE = { key: 'displayName', order: 'asc' } as const;
/** Space reserved above the dashboard body (header, filter tags, padding). */
export const VIEWPORT_OFFSET = 160;
/** Initial map view (Argentina) until the first fit-all over the markers. */
export const DEFAULT_MAP_CENTER: [number, number] = [-38.4161, -63.6167];
export const DEFAULT_MAP_ZOOM = 4;
export const USER_LIST_ROW_HEIGHT = 56;
export const USER_LIST_MOBILE_ROW_HEIGHT = 72;
export const USER_LIST_MOBILE_HEADER_HEIGHT = 84;
export const USER_LIST_MOBILE_SEARCH_HEIGHT = 69;
export const MOBILE_USER_SEARCH_THRESHOLD = 10;
export const USER_LIST_HEADER_HEIGHT = 40;
export const USER_LIST_PAGINATION_HEIGHT = 48;
/** Desktop panel height unavailable for rows: overlay insets plus the title/KPI bar. */
export const USER_LIST_DESKTOP_RESERVED_HEIGHT = 110;
